<template>
  <div class="event-participants-filter">
    <snow-select
      v-model="checkIn"
      label="Check-in"
      :options="checkInOptions"
      class="mb-7"
    />

    <div class="d-flex flex-lg-row flex-column gap-3">
      <snow-button
        class="w-100 order-1 order-lg-0"
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button class="w-100" size="lg" text="Aplicar" @click="apply" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      checkIn: this.getCheckIn(),
      checkInOptions: [
        { id: "all", name: "Todos" },
        { id: "done", name: "Realizado" },
        { id: "pending", name: "Pendente" }
      ]
    };
  },
  methods: {
    apply() {
      const mapCheckin = {
        all: "",
        pending: false,
        done: true
      };

      this.$emit("apply", { checkin_done: mapCheckin[this.checkIn] });
      this.$emit("close");
    },
    getCheckIn() {
      const checkIn = this.filters.checkin_done;

      if (checkIn === false) return "pending";
      else if (checkIn === true) return "done";
      return "all";
    }
  }
};
</script>
